import * as React from 'react';
import Modal from '../../../misc/components/modal';
import { ReprocessState } from "../CoughSessionsListReducer";
import { isModelWithError } from '../../../misc/api/apiTypes';
import { AuditModalBody } from '../../../auditmodal/components/AuditModalBody';
import ReprocessCoughSessionCompletion from './ReprocessCoughSessionModal/ReprocessCoughSessionCompletion';
import ReprocessCoughSessionConfirmation from './ReprocessCoughSessionModal/ReprocessCoughSessionConfirmation';
import { CoughSession } from 'webportalclient';
import { AuditForm } from '../../../auditmodal/components/AuditModal';
import { useCoughMarshalApiClient } from '../../../misc/api/CoughMarshalApiClient';
import { useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';

declare const rootUrl: string;

export interface ReprocessCoughSessionModalProps {
    coughSession: CoughSession;
    onClose: () => void;
}

export const ReprocessCoughSessionModal = (props: ReprocessCoughSessionModalProps) => {
    const [error, setError] = React.useState<string>();
    const coughMarshalClient = useCoughMarshalApiClient();
    const [reprocessState, setReprocessState] = React.useState<ReprocessState>(ReprocessState.Confirmation);
    const legacyClient = useWebPortalLegacyClient();

    const getHeader = () => `Reprocess Cough Session ${props.coughSession.name}`;

    const handleAuditSubmit = (auditForm: AuditForm) => {
        const onReprocess = (coughSessionId: string, auditAnnotation: string) => {
            legacyClient.reprocessWaveforms(coughSessionId, auditAnnotation)
                .then(reprocessSessionResult => {
                        if (isModelWithError(reprocessSessionResult)) {
                            setError(reprocessSessionResult.Errors[0].Message);
                        }

                        coughMarshalClient.reProcessRequest(coughSessionId)
                            .then(response => props.onClose());
                })
                .catch(err => {
                    setError(err.Message);
                });
        }

        onReprocess(props.coughSession.id, auditForm.Annotation);
    }

    const getContent = () => {
        switch (reprocessState) {
            case ReprocessState.Confirmation:
                return <div>
                    <ReprocessCoughSessionConfirmation
                        coughSession={props.coughSession}
                        backText={getBackText()}
                        nextText={getNextText()}
                        onCancel={() => { onCancel(); }}
                        onNext={() => { setReprocessState(ReprocessState.AuditTrail); }}
                    />
                </div>;
            case ReprocessState.AuditTrail:
                return <AuditModalBody
                    isSubmitting={false}
                    onClose={() => onCancel()}
                    onSubmit={(auditForm) => handleAuditSubmit(auditForm)}
                >
                </AuditModalBody>;
            case ReprocessState.Complete:
                return <div>
                    <ReprocessCoughSessionCompletion
                        backText={getBackText()}
                        nextText={getNextText()}
                        onCancel={() => { onCancel(); }}
                        onNext={() => { props.onClose(); }}
                    />
                </div>;
            default:
                return null;
        }
    }

    const getBackText = () => {
        return "Cancel";
    }

    const getNextText = () => {
        return getNextState() != null ? "Next" : "Done";
    }

    const onCancel = () => {
        props.onClose();
    }

    const getNextState = () => {
        switch (reprocessState) {
            case ReprocessState.Confirmation:
                return ReprocessState.AuditTrail;
            case ReprocessState.AuditTrail:
                return props.onClose();
            default:
                return null;
        }
    }

    return (
        <Modal show={true} closeModalHandler={() => onCancel()} header={getHeader()}>
            {getContent()}
        </Modal>
    );
}



